import React from "react";
import '../styles/global-api-loader.css';
const GlobalApiLoader = () => {
    return (
        <div className="wrap-loader">
            <span className="global-api-loader"></span>
        </div>
    );
};
export default GlobalApiLoader;
